/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Text } from 'Component/Ajaib';

import IMG_DOWNLOAD_PAGE from 'Image/img-download-page.png';
import IMG_DOWNLOAD_PAGE_MOBILE from 'Image/img-download-mobile-new.png';
import IMG_BUTTON_IOS from 'Image/img-button-ios.png';
import IMG_BUTTON_GOOGLE from 'Image/img-button-google.png';

import stylesGlobal from '../style';

const DownloadPage = () => {
  window.onload = function () {
    setTimeout(() => {
      window.location.href = 'https://referral.ajaib.co.id/KDiu';
    }, 1000);
  };
  return (
    <Col md={12} sm={12} style={{ width: '100%', height: '100%' }}>
      <Row
        noGutters
        className="align-items-center download-page-container hidden-xs"
      >
        <Col md={4} sm={4} className="p-0">
          <img
            src={IMG_DOWNLOAD_PAGE_MOBILE}
            className="download-image"
            style={{ width: 283.75, height: 183.4, marginBottom: 0 }}
            onClick={() => {
              window.location.href = 'https://referral.ajaib.co.id/KDiu';
            }}
          />
        </Col>
        <Col className="p-0 ml-24 content-download">
          <Col className="p-0 mb-24">
            <Text
              onClick={() => {
                window.location.href = 'https://referral.ajaib.co.id/KDiu';
              }}
              size="sub-section-active"
              color="blue"
              bold
            >
              Yuk Download Ajaib App Sekarang !
            </Text>
          </Col>
          <Col className="p-0">
            <Text
              onClick={() => {
                window.location.href = 'https://referral.ajaib.co.id/KDiu';
              }}
              size="body-bold"
              style={{ lineHeight: '24px' }}
              color={stylesGlobal.neutral700}
            >
              Halo ! Untuk pengalaman terbaik di ponsel mu, kami sudah
              menyiapkan aplikasi Ajaib yang dapat kamu download dibawah ini.
            </Text>
          </Col>
          <Row noGutters className="mt-40">
            <img
              style={{ cursor: 'pointer' }}
              src={IMG_BUTTON_GOOGLE}
              className="mr-24"
              onClick={() => {
                window.location.href =
                  'https://play.google.com/store/apps/details?id=ajaib.co.id';
              }}
            />
            <img
              style={{ cursor: 'pointer' }}
              src={IMG_BUTTON_IOS}
              onClick={() => {
                window.location.href =
                  'https://apps.apple.com/id/app/ajaib-easy-online-investment/id1473916571';
              }}
            />
          </Row>
        </Col>
      </Row>
      <Row className="align-items-center download-page-container hidden-lg">
        <Col md={12} sm={12} className="p-0">
          <Col className="text-center p-0 content-download">
            <Col className="p-0 mb-24">
              <Text
                onClick={() => {
                  window.location.href = 'https://referral.ajaib.co.id/KDiu';
                }}
                size="sub-section-active"
                color="blue"
                bold
              >
                Yuk Download Ajaib App Sekarang !
              </Text>
            </Col>
            <Col className="p-0">
              <Text
                onClick={() => {
                  window.location.href = 'https://referral.ajaib.co.id/KDiu';
                }}
                size="body-bold"
                style={{ lineHeight: '24px' }}
                color={stylesGlobal.neutral700}
              >
                Halo ! Untuk pengalaman terbaik di ponsel mu, kami sudah
                menyiapkan aplikasi Ajaib yang dapat kamu download dibawah ini.
              </Text>
            </Col>
            <Col className="p-0 hidden-lg justify-content-center mt-28">
              <img
                onClick={() => {
                  window.location.href = 'https://referral.ajaib.co.id/KDiu';
                }}
                src={IMG_DOWNLOAD_PAGE_MOBILE}
                className="download-image"
                style={{ width: 283.75, height: 183.4, marginBottom: 0 }}
              />
            </Col>
            <Row noGutters className="mt-36">
              <Col xs={6} className="pl-0 pr-12">
                <img
                  style={{ cursor: 'pointer' }}
                  src={IMG_BUTTON_GOOGLE}
                  className="mr-24"
                  onClick={() => {
                    window.location.href =
                      'https://play.google.com/store/apps/details?id=ajaib.co.id';
                  }}
                />
              </Col>
              <Col xs={6} className="pr-0 pl-12">
                <img
                  style={{ cursor: 'pointer' }}
                  src={IMG_BUTTON_IOS}
                  onClick={() => {
                    window.location.href =
                      'https://apps.apple.com/id/app/ajaib-easy-online-investment/id1473916571';
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    </Col>
  );
};

export default DownloadPage;
